import { Entity } from '@adornis/baseql/decorators.js';
import { BHOrderNr } from '@adornis/buchungsheld-db/entities/BHPayment.js';
import { getIncrementingNumber } from '@adornis/counter/api/counter.operations.js';

@Entity()
export class BHDemoOrderNr extends BHOrderNr {
  static override _class = 'BHDemoOrderNr';

  static override async create(institutionID: string) {
    const year = new Date().getFullYear();
    const nr = await getIncrementingNumber(institutionID + '::orderCounter::' + year)();
    return new BHDemoOrderNr({ year, nr });
  }

  override getOrderNr() {
    const padNr = this.nr.toString().padStart(4, '0');
    return `05/${this.year}/HDW/${padNr}`;
  }
}
